(function() {
  if (!customElements.get("number-counter")) {
    customElements.define(
      "number-counter",
      class NumberCounter extends HTMLElement {
        constructor() {
          super();
          this.currentNumber = BigInt(0);
          this.targetNumber = BigInt(0);
          this.isAnimating = false;
        }

        connectedCallback() {
          this.initProperties();
          this.counterDisplay = this.querySelector(".counter-display");
          if (!this.counterDisplay) {
            console.error("Number Counter: Counter display element not found.");
            return;
          }

          // Ensure startNumber is BigInt
          this.currentNumber = typeof this.startNumber === 'bigint' ? this.startNumber : BigInt(this.startNumber);
          this.targetNumber = this.currentNumber;
          
          console.log("Number Counter: Initializing with number", this.currentNumber.toString());
          this.renderCounter();

          // Start auto increment if enabled
          if (this.autoIncrement) {
            this.startAutoIncrement();
          }
        }

      initProperties() {
        const startNumberAttr = this.getAttribute("data-start-number");
        try {
          this.startNumber = startNumberAttr ? BigInt(startNumberAttr) : BigInt(20000);
          if (this.startNumber < 0) this.startNumber = BigInt(0);
        } catch (e) {
          console.warn("Number Counter: Invalid start number, using default 20000");
          this.startNumber = BigInt(20000);
        }

        const maxNumberAttr = this.getAttribute("data-max-number");
        try {
          this.maxNumber = maxNumberAttr ? BigInt(maxNumberAttr) : BigInt(999999999);
          if (this.maxNumber < this.startNumber) this.maxNumber = this.startNumber;
        } catch (e) {
          console.warn("Number Counter: Invalid max number, using default 999999999");
          this.maxNumber = BigInt(999999999);
        }
        
        const incrementSpeedAttr = this.getAttribute("data-increment-speed");
        this.incrementSpeed = incrementSpeedAttr ? Math.max(1, parseInt(incrementSpeedAttr, 10)) : 1000;
        
        const autoIncrementAttr = this.getAttribute("data-auto-increment");
        this.autoIncrement = autoIncrementAttr === "true" || autoIncrementAttr === true;
        
        const incrementAmountAttr = this.getAttribute("data-increment-amount");
        try {
          this.incrementAmount = incrementAmountAttr ? BigInt(incrementAmountAttr) : BigInt(1);
          if (this.incrementAmount < 1) this.incrementAmount = BigInt(1);
        } catch (e) {
          console.warn("Number Counter: Invalid increment amount, using default 1");
          this.incrementAmount = BigInt(1);
        }
      }

      startAutoIncrement() {
        this.autoIncrementInterval = setInterval(() => {
          if (this.targetNumber >= this.maxNumber) return;
          this.increment(this.incrementAmount);
        }, this.incrementSpeed);
      }

      increment(amount = 1) {
        if (this.targetNumber >= this.maxNumber) return;
        // Convert amount to BigInt if needed
        let safeAmount;
        if (typeof amount === 'bigint') {
          safeAmount = amount > 0 ? amount : BigInt(1);
        } else {
          try {
            safeAmount = BigInt(Math.max(1, Math.floor(amount)));
          } catch (e) {
            safeAmount = BigInt(1);
          }
        }
        let next = this.targetNumber + safeAmount;
        if (next > this.maxNumber) next = this.maxNumber;
        this.targetNumber = next;
        this.animateToNumber(this.targetNumber);
      }

      setNumber(number) {
        // Convert number to BigInt and clamp to max
        try {
          let num;
          if (typeof number === 'bigint') {
            num = number >= 0 ? number : BigInt(0);
          } else {
            num = BigInt(Math.max(0, Math.floor(number)));
          }
          this.targetNumber = num > this.maxNumber ? this.maxNumber : num;
        } catch (e) {
          console.warn("Number Counter: Invalid number provided, ignoring");
          return;
        }
        this.animateToNumber(this.targetNumber);
      }

      animateToNumber(targetNumber) {
        const oldNumber = this.currentNumber;
        // Ensure targetNumber is BigInt and clamp to max
        let newNumber;
        if (typeof targetNumber === 'bigint') {
          newNumber = targetNumber >= 0 ? targetNumber : BigInt(0);
        } else {
          try {
            newNumber = BigInt(Math.max(0, Math.floor(targetNumber)));
          } catch (e) {
            console.warn("Number Counter: Invalid target number, ignoring");
            return;
          }
        }
        if (newNumber > this.maxNumber) newNumber = this.maxNumber;

        if (oldNumber === newNumber) {
          return;
        }

        // Format numbers as strings for digit comparison
        const oldFormatted = oldNumber.toString();
        const newFormatted = newNumber.toString();

        // If number of digits changed, re-render completely
        if (oldFormatted.length !== newFormatted.length) {
          this.currentNumber = newNumber;
          this.renderCounter();
          return;
        }

        // Get segments (excluding commas) in display order
        const segments = Array.from(
          this.counterDisplay.querySelectorAll(".counter-segment:not(.comma)")
        );

        // Compare digits from left to right (matching display order)
        // Only animate digits that actually changed
        let hasChanges = false;
        segments.forEach((segment, index) => {
          const oldDigit = oldFormatted[index] || "0";
          const newDigit = newFormatted[index] || "0";

          if (oldDigit !== newDigit) {
            hasChanges = true;
            const digitElement = segment.querySelector(".counter-digit.current");
            if (digitElement) {
              // Create new digit element
              const newDigitElement = document.createElement("div");
              newDigitElement.className = "counter-digit next";
              newDigitElement.textContent = newDigit;
              segment.querySelector(".counter-digit-wrapper").appendChild(newDigitElement);

              // Trigger animation
              requestAnimationFrame(() => {
                digitElement.classList.add("flipping-up");
                newDigitElement.classList.add("flipping-down");
              });

              // Clean up after animation
              setTimeout(() => {
                digitElement.remove();
                newDigitElement.classList.remove("next", "flipping-down");
                newDigitElement.classList.add("current");
              }, 600);
            }
          }
        });

        // If no segments matched (shouldn't happen, but safety check)
        if (!hasChanges && segments.length !== oldFormatted.length) {
          this.currentNumber = newNumber;
          this.renderCounter();
          return;
        }

        this.currentNumber = newNumber;
      }

      formatNumber(number) {
        // BigInt.toString() handles very large numbers correctly
        if (typeof number === 'bigint') {
          return number.toString();
        }
        return BigInt(Math.max(0, Math.floor(number))).toString();
      }

      renderCounter() {
        if (!this.counterDisplay) {
          console.error("Number Counter: Cannot render - counter display not found");
          return;
        }

        // Ensure currentNumber is BigInt and format it
        const numberString = this.formatNumber(this.currentNumber);
        const digits = numberString.split("");

        console.log("Number Counter: Rendering", this.currentNumber, "as digits:", digits);

        this.counterDisplay.innerHTML = "";

        digits.forEach((digit, index) => {
          // Calculate position from right (0-based)
          const positionFromRight = digits.length - index - 1;
          
          // Add comma BEFORE groups of 3 digits from the right
          // For "20023" → "200,23" (comma moved one position to the right)
          // We want commas at positions: 2, 5, 8... from right
          // So we add a comma when positionFromRight is 2, 5, 8... (before those positions)
          if (positionFromRight > 0 && positionFromRight % 3 === 2) {
            const commaSegment = document.createElement("div");
            commaSegment.className = "counter-segment comma";
            this.counterDisplay.appendChild(commaSegment);
          }

          // Add digit segment
          const segment = document.createElement("div");
          segment.className = "counter-segment";

          const digitWrapper = document.createElement("div");
          digitWrapper.className = "counter-digit-wrapper";

          const digitElement = document.createElement("div");
          digitElement.className = "counter-digit current";
          digitElement.textContent = digit;

          digitWrapper.appendChild(digitElement);
          segment.appendChild(digitWrapper);
          this.counterDisplay.appendChild(segment);
        });

        console.log("Number Counter: Rendered", this.counterDisplay.children.length, "segments");
      }

      disconnectedCallback() {
        if (this.autoIncrementInterval) {
          clearInterval(this.autoIncrementInterval);
        }
      }
    }
  );
}

  // Initialize any existing number-counter elements on the page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCounters);
  } else {
    initializeCounters();
  }

  function initializeCounters() {
    const counters = document.querySelectorAll('number-counter:not([data-initialized])');
    counters.forEach(counter => {
      if (counter.shadowRoot === null) {
        counter.setAttribute('data-initialized', 'true');
      }
    });
  }
})();

